<template>
  <b-modal
    centered
    v-model="editorShown"
    title="Change Password"
    header-bg-variant="primary"
    header-text-variant="white"
    no-close-on-backdrop
    header-class="bg-purple"
  >
    <template v-slot:modal-footer>
      <b-button
        class="bg-med-light-gray"
        variant="light"
        @click="editorShown = false"
      >
        Cancel
      </b-button>
      <b-button variant="primary" @click.prevent="submitPasswordChange">
        Save
      </b-button>
    </template>
    <b-form-group
      label="Current Password"
      :invalid-feedback="formErrors.currentPassword.join(', ')"
      :state="formErrors.currentPassword.length == 0 ? null : false"
    >
      <b-form-input
        type="password"
        v-model="form.currentPassword"
        trim
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="New Password"
      :invalid-feedback="formErrors.newPassword.join(', ')"
      :state="formErrors.newPassword.length == 0 ? null : false"
    >
      <b-form-input
        type="password"
        v-model="form.newPassword"
        trim
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Confirm New Password"
      :invalid-feedback="formErrors.confirmPassword.join(', ')"
      :state="formErrors.confirmPassword.length == 0 ? null : false"
    >
      <b-form-input
        type="password"
        v-model="form.confirmPassword"
        trim
      ></b-form-input>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";
import userServer from "../../server/user";
import { validateRequired } from "../../helpers/validation";

export default {
  name: "ChangePasswordModal",
  data() {
    return {
      form: {
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      formErrors: {
        currentPassword: [],
        newPassword: [],
        confirmPassword: []
      }
    };
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "fetchCurrentUser",
      "showError"
    ]),
    async submitPasswordChange() {
      if (!this.validatePasswordChange()) {
        return;
      }

      await userServer
        .changeCurrentUserPassword({
          currentPassword: this.form.currentPassword,
          newPassword: this.form.newPassword,
          confirmation: this.form.confirmPassword
        })
        .then(() => {
          this.fetchCurrentUser();
          this.showAlertSuccess();
          this.editorShown = false;
        })
        .catch(error => {
          if (error.response.data.errorCode == "incorrectPassword") {
            this.showError({
              message: "Wrong current password"
            });
          }
        });
    },
    validatePasswordChange() {
      this.formErrors.currentPassword = [];
      this.formErrors.newPassword = [];
      this.formErrors.confirmPassword = [];

      let withoutErrors = true;

      if (!validateRequired(this.form.currentPassword)) {
        this.formErrors.currentPassword.push("This field is required");
        withoutErrors = false;
      }

      if (!validateRequired(this.form.newPassword)) {
        this.formErrors.newPassword.push("This field is required");
        withoutErrors = false;
      } else if (this.form.newPassword.length < 8) {
        this.formErrors.newPassword.push(
          "The password must be at least 8 characters long"
        );
        withoutErrors = false;
      }

      if (!validateRequired(this.form.confirmPassword)) {
        this.formErrors.confirmPassword.push("This field is required");
        withoutErrors = false;
      } else if (this.form.newPassword != this.form.confirmPassword) {
        this.formErrors.confirmPassword.push("Passwords do not match");
        withoutErrors = false;
      }

      return withoutErrors;
    }
  },
  computed: {
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style></style>
